import { toast } from "react-toastify";

const sendSms = async (phone) => {
  try {
    const res = await fetch("https://api.marvellife.co/api/v2/users/send-sms", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ phone }),
    });

    const text = await res.text();

    try {
      const json = JSON.parse(text);

      if (!res.ok) {
        throw new Error(json.message);
      }

      toast.success(json.message);
      return json;
    } catch {
      if (!res.ok) {
        throw new Error(text);
      }

      toast.success("کد ارسال شد");
      return { message: text };
    }
  } catch (error) {
    try {
      const parsed = JSON.parse(error.message);
      toast.error(parsed.message);
    } catch {
      toast.error(error.message);
    }

    throw error;
  }
};

export default sendSms;
